import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class MaterialService {
    constructor(http) {
        this.http = http;
        this.singular = 'material';
        this.plural = 'materials';
        this.editor = PLATFORM.moduleName('pages/system-fields/materials/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`materials/filter/${loadOptions}`);
        return await response.json();
    }

    async create(material) {
        await this.http.fetch('materials', { method: 'POST', body: json(material) });
    }

    async update(material) {
        await this.http.fetch(`materials/${material.id}`, { method: 'PUT', body: json(material) });
    }

    async delete(id) {
        await this.http.fetch(`materials/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`materials/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`materials/top-three/${query}`);
        return await response.json();
    }
}